import { AfterViewInit, Component, Injector } from '@angular/core';
import { GroupFilterModel } from "../../shared/pipes/FilterByNameAndGroup.pipe";
import {IManagableObject} from "../IManagableObject";
import {TranslateService} from "@ngx-translate/core";
import {Observable} from "rxjs";
import {BaseComponentWithDialog} from "./base-component-with-dialog";
import { PageInfo } from '../../shared/components/pagination/pagination.component';

@Component({
    selector: 'app-base-admin-panel',
    template: '',
    standalone: false
})
export class BaseAdminPanelComponent extends BaseComponentWithDialog implements AfterViewInit {
  public objects: IManagableObject[] = [];
  public nameFilter: string = "";
  public filter: GroupFilterModel = new GroupFilterModel();
  public entityName: string = "";
  public pageInfoFilter = new PageInfo();

  protected translate: TranslateService;

  constructor(injector: Injector) {
    super(injector);
    this.translate = injector.get(TranslateService);
  }

  ngAfterViewInit() {
    //super.ngAfterViewInit();
    window.dispatchEvent(new CustomEvent("ComponentLoad", {detail: "AdminPanelComponent"}));
  }

  // method that deletes the entity by their id
  protected doDeleteObject(id: number): Observable<any> {
    return undefined;
  };

  // method that deletes entities by their ids
  protected doDeleteObjects(ids: number[]): Observable<any> {
    return undefined;
  };

  // handler that is triggered when entities are deleted
  protected onDeletingObjects(ids: number[]): void {
    this.objects = this.objects.filter(e => !ids.includes(e.Id));
  }

  // handler that is triggered when an entity is deleted
  protected onDeletingObject(entity: any): void {
    //if (this.entityName)
    //  this.syncService.NotifyEntityChanged(this.entityName, entity.Id);
    let searchElement = this.objects.find(c => c.Id == entity.Id);
    let start = this.objects.indexOf(searchElement);
    this.objects.splice(start, 1);
  }

  public onTermChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.filter.term = input.value;
  }

  public deleteObject(id: number) {
    let entity = this.objects.find(com => com.Id == id);
    if (!entity) return;
    let message = this.translate.instant("Delete");
    if (!confirm(message + " " + entity.Name + "?")) return;
    this.doDeleteObject(id).subscribe(() => {
      if (this.entityName)
        this.syncService.NotifyEntityChanged(this.entityName, id);

      this.Refresh();
    });
  }

  public deleteSelected() {
    let entities = this.objects.filter(c => c.IsChecked);
    if (entities.length == 0) return;
    let message = this.translate.instant("Delete selected items?");
    if (!confirm(message)) return;

    const isOverriddenRemoveRange = this.doDeleteObjects !== BaseAdminPanelComponent.prototype.doDeleteObjects;
    const isOverriddenRemove = this.doDeleteObject !== BaseAdminPanelComponent.prototype.doDeleteObject;

    if (isOverriddenRemoveRange) {
      let ids = entities.map(e => e.Id);
      this.doDeleteObjects(ids).subscribe(() => {
        this.onDeletingObjects(ids);
      })
    }
    else if (isOverriddenRemove) {
      entities.forEach((entity) => {
        this.doDeleteObject(entity.Id).subscribe(() => {
          this.onDeletingObject(entity);
        });
      });
    }
    else
      throw new Error("Not implemented.");
  }

  public onToggleAll(value: boolean) {
    this.objects.forEach((command) => {
      command.IsChecked = value;
    });
  }

  public onPageChange(pageInfo: PageInfo)
  {
    this.pageInfoFilter = pageInfo;
  }

}
